import { useState } from 'react';
import { fetchDianAcquirerInfo } from '../services/client.service';
import { isValidDianQuery, parseDianResponse } from '../utils/validateResponseApi';

export const useDianAutocomplete = ({
    token,
    dto,
    handleDirectInputChange,
    sendNotification,
    fieldMap,
    checkDuplicate,
    duplicateMsg = 'Este registro ya existe en el sistema.',
}) => {
    const [loadingDian, setLoadingDian] = useState(false);

    const fetchDianInfo = async (overrides = {}) => {
        const type_identification = overrides?.type_identification ?? dto.type_identification;
        const identification = overrides?.identification ?? dto.identification;

        if (!isValidDianQuery(type_identification, identification)) return;

        setLoadingDian(true);
        try {
            const { data } = await fetchDianAcquirerInfo(token, {
                receiver_id: identification,
                receiver_tax_id: type_identification,
            });
            const result = parseDianResponse(data);
            if (!result.isSuccess) return;

            Object.entries(fieldMap).forEach(([formField, dianKey]) => {
                const value = result[dianKey];
                if (value !== null && value !== undefined && value !== '' && !(Array.isArray(value) && !value.length)) {
                    handleDirectInputChange(formField, value);
                }
            });
        } catch (e) {
            console.error('Error DIAN:', e?.response?.data ?? e.message);
        } finally {
            setLoadingDian(false);
        }
    };

    const handleNitChange = ({ target }) => {
        handleDirectInputChange('identification', target.value);

        if (checkDuplicate && target.value.length > 7) {
            setTimeout(async () => {
                try {
                    const res = await checkDuplicate(target.value);
                    if (res?.data) {
                        handleDirectInputChange('identification', '');
                        handleDirectInputChange('identification_digit', '');
                        sendNotification({ msg: duplicateMsg, variant: 'info' });
                    }
                } catch (_) { /* no existe → OK */ }
            }, 1000);
        }
    };

    return { loadingDian, fetchDianInfo, handleNitChange };
};
